module.exports = __webpack_public_path__ + "img/13.41aa38c7.jpg";